import { api } from '../../services/api'

const state = () => ({ items: [], loading: false, error: null })

const getters = {
  all: s => {
    console.log('[Getter] all → items:', s.items)
    return s.items
  }
}

const mutations = {
  SET_ITEMS(state, items) {
    console.log('[Mutation] SET_ITEMS → received:', items)
    state.items = Array.isArray(items) ? items : []
    console.log('[Mutation] SET_ITEMS → state.items now:', state.items)
  },
  ADD_ITEM(state, item) {
    console.log('[Mutation] ADD_ITEM → new item:', item)
    state.items.unshift(item)
    console.log('[Mutation] ADD_ITEM → state.items now:', state.items)
  },
  UPDATE_ITEM(state, item) {
    console.log('[Mutation] UPDATE_ITEM → looking for id:', item.id)
    const i = state.items.findIndex(x => String(x.id) === String(item.id))
    console.log('[Mutation] UPDATE_ITEM → found at index:', i)
    if (i !== -1) {
      state.items.splice(i, 1, item)
      console.log('[Mutation] UPDATE_ITEM → updated item:', item)
    } else {
      console.warn('[Mutation] UPDATE_ITEM → item NOT found in state!')
    }
  },
  REMOVE_ITEM(state, id) {
    console.log('[Mutation] REMOVE_ITEM → removing id:', id)
    state.items = state.items.filter(x => String(x.id) !== String(id))
    console.log('[Mutation] REMOVE_ITEM → state.items now:', state.items)
  },
  SET_LOADING(state, v) {
    console.log('[Mutation] SET_LOADING →', v)
    state.loading = v
  },
  SET_ERROR(state, e) {
    console.log('[Mutation] SET_ERROR →', e)
    state.error = e
  }
}

const actions = {
  async list({ commit }) {
    console.log('[Action] list → starting...')
    commit('SET_LOADING', true)
    try {
      console.log('[Action] list → calling API: GET admin/sales-records')
      const { data } = await api.get('admin/sales-records')
      console.log('[Action] list → API response raw data:', data)

      const items = Array.isArray(data) ? data : (data?.items || [])
      console.log('[Action] list → parsed items:', items)

      commit('SET_ITEMS', items)
      commit('SET_ERROR', null)
      console.log('[Action] list → done ✅')
    } catch (e) {
      console.error('[Action] list → ERROR:', e)
      console.error('[Action] list → response:', e.response)
      console.error('[Action] list → response data:', e.response?.data)
      commit('SET_ERROR', e.response?.data?.error || e.message || 'Failed to load sales')
    } finally {
      commit('SET_LOADING', false)
      console.log('[Action] list → loading set to false')
    }
  },

  async create({ commit }, payload) {
    console.log('[Action] create → payload:', payload)
    if (payload instanceof FormData) {
      console.log('[Action] create → FormData entries:')
      for (let [key, value] of payload.entries()) {
        console.log(`   ${key}:`, value)
      }
    }
    try {
      console.log('[Action] create → calling API: POST admin/sales-records')
      const { data } = await api.post('admin/sales-records', payload)
      console.log('[Action] create → API response:', data)
      commit('ADD_ITEM', data)
      console.log('[Action] create → done ✅')
      return data
    } catch (e) {
      console.error('[Action] create → ERROR:', e)
      console.error('[Action] create → response data:', e.response?.data)
      throw e
    }
  },

  async update({ commit }, { id, payload }) {
    console.log('[Action] update → id:', id)
    console.log('[Action] update → payload:', payload)

    try {
      if (payload instanceof FormData) {
        console.log('[Action] update → payload is FormData, using POST + _method=PUT')
        payload.append('_method', 'PUT')
        console.log('[Action] update → FormData entries:')
        for (let [key, value] of payload.entries()) {
          console.log(`   ${key}:`, value)
        }
        console.log(`[Action] update → calling API: POST admin/sales-records/${id}`)
        const { data } = await api.post(`admin/sales-records/${id}`, payload)
        console.log('[Action] update → API response:', data)
        commit('UPDATE_ITEM', data)
        console.log('[Action] update → done ✅')
        return data
      }

      console.log(`[Action] update → calling API: PUT admin/sales-records/${id}`)
      const { data } = await api.put(`admin/sales-records/${id}`, payload)
      console.log('[Action] update → API response:', data)
      commit('UPDATE_ITEM', data)
      console.log('[Action] update → done ✅')
      return data
    } catch (e) {
      console.error('[Action] update → ERROR:', e)
      console.error('[Action] update → response data:', e.response?.data)
      throw e
    }
  },

  async remove({ commit }, id) {
    console.log('[Action] remove → id:', id)
    try {
      console.log(`[Action] remove → calling API: DELETE admin/sales-records/${id}`)
      await api.delete(`admin/sales-records/${id}`)
      console.log('[Action] remove → API call success')
      commit('REMOVE_ITEM', id)
      console.log('[Action] remove → done ✅')
    } catch (e) {
      console.error('[Action] remove → ERROR:', e)
      console.error('[Action] remove → response data:', e.response?.data)
      throw e
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}